export enum Themes {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system'
}

export const LOCAL_STORAGE_THEME_SELECTED_KEY = 'odo-settings-theme'
